// extracted by mini-css-extract-plugin
export default {"page":"SG9K2s"};